let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fuMFl")).then(() => parcelRequire('4vWem'));